var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BravadoText',{staticClass:"header-menu-notifications-card-commission",attrs:{"variant":"subhead"}},[_c('CommissionIcon',{staticClass:"header-menu-notifications-card-commission__icon"}),_vm._v("\n  +"+_vm._s(_vm.value)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }